import React from 'react';
import { Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { UploadDTO } from '@api/upload/dto/UploadDTO';
import useDownloadFile from '@api/filesUpload/hooks/useDownloadFile';
import useGetUser from '@api/user/hooks/useGetUser';

type Props = {
  uploadDTO: UploadDTO;
};

function DownloadFileSetOption({ uploadDTO }: Props) {
  const { t } = useTranslation();
  const { downloadFile } = useDownloadFile(uploadDTO.id, { enabled: false }, true);
  const canRender = true;
  const { data: user } = useGetUser();

  if (!user || !canRender) {
    return null;
  }

  return (
    <Button
      content={t('upload.download')}
      icon="download"
      labelPosition="left"
      onClick={() => downloadFile()}
    />
  );
}

export default DownloadFileSetOption;
